<template>
  <div class="container about">
    <div class="page-title">
      <h2 class="title__h2">Sobre Mi</h2>
    </div>
    <section class="about-container">
      <div class="about-me">
        <div class="description-container">
          <description-about></description-about>

          <grid-about
            :personalInfo="personalInfo"
            :percentages="percentages"
          ></grid-about>

          <div class="about-buttons">
            <a :href="curriculum" target="__blank" class="button">Descargar CV</a>
            <router-link class="button about-contact" :to="{ name: 'Contacto' }"
              >Contáctame</router-link
            >
            <a href="#timelines" class="button exp-button">Experiencia</a>
          </div>
        </div>
        <timeline-about
          :education="education"
          :experiences="experiences"
        ></timeline-about>
      </div>
    </section>
  </div>
</template>

<script>
import DescriptionAbout from "@/components/About/Description.vue";
import GridAbout from "@/components/About/Grid.vue";
import TimelineAbout from "@/components/About/Timeline.vue";
export default {
  name: "AboutView",
  components: {
    DescriptionAbout,
    GridAbout,
    TimelineAbout,
  },
  data() {
    return {
      curriculum: 'files/CurriculumAmilcar.pdf',
      personalInfo: [
        { name: "Fecha de Nacimiento", data: "16/01/1996", link: false },
        {
          name: "Sitio Web",
          data: "http://" + window.location.host,
          link: true,
          router: "Inicio",
        },
        { name: "Tiempo Completo", data: "Si", link: false },
        { name: "Freelance", data: "Si", link: false },
        { name: "Disponibilidad", data: "Inmediata", link: false },
        { name: "País", data: "Venezuela", link: false },
        { name: "Edad", data: "26 años", link: false },
        { name: "Correo", data: "amilcar.coronado64@gmail.com", link: false },
      ],
      percentages: [
        { name: "CSS", width: "85%" },
        { name: "HTML", width: "90%" },
        { name: "Javascript", width: "75%" },
        { name: "PHP", width: "85%" },
        { name: "Bootstrap 4", width: "80%" },
        { name: "VueJs", width: "60%" },
        { name: "Laravel", width: "75%" },
        { name: "SASS", width: "70%" },
        { name: "jQuery", width: "75%" },
        { name: "Ajax", width: "75%" },
        { name: "MySQL", width: "75%" },
      ],
      education: [
        {
          year: "2022",
          job: "Curso de Desarrollo de Aplicaciones Web con Gatsby JS  / Platzi",
          description:
            "Curso de Gatsby donde aprender a instalar y configurar Gatsby desde cero, crear vistas de una app web con Gatsby y React, conectar tu aplicación en Gatsby a una API en GraphQL, crear páginas web programáticamente con Gatsby",
        },
        {
          year: "2022",
          job: "Curso de Next JS  / Platzi",
          description:
            "Curso de NextJS básico donde se aprende a renderizar aplicaciones en el servidor, SSR, desarrollar APIs con Next.js, como desplegar una webapp a producción, como crear Single Page Applications con Next.js",
        },
        {
          year: "2022",
          job: "Curso Profesional de CSS Grid Layout / Platzi",
          description:
            "Curso de maquetación en CSS Grid donde se aprende a emplear funciones como repeat, minmax y fit-content, comprender la relación de contenedores padres con sus elementos hijos, utilizar propiedades físicas y lógicas en CSS, y poner en práctica técnicas de alineamiento con Flexbox y CSS Grid.",
        },    
        {
          year: "2021",
          job: "Desarrollo Web Completo HTML5, CSS3, JS, Ajax, PHP, MySQL / Udemy",
          description:
            "Curso lleno de tips y técnicas, además de la creación de múltiples proyectos web con funciones avanzadas y áreas de administración que permitan el dinamismo en los proyectos. Manejo de tecnologías como: PHP, CSS, SASS, Workflows, JavaScript, Fetch, PHP, MVC, MySQL y API's."
        },
        {
          year: "2021",
          job: "Master en PHP, SQL, POO, MVC, Laravel, Symfony, Wp y más / Udemy",
          description:
            "Manejo de fundamentos técnicos básicos y avanzados en PHP, SQL, Conceptos de POO y MVC. Maquetación web y manejo básico de CMS (WORDPRESS).",
        },
        {
          year: "2021",
          job: "Bases de datos con MySQL / Udemy",
          description:
            "Manejo de bases de datos básico y avanzado. Fases del diseño de bases de datos, normalización. Programación de bucles condicionales, If-Then-Else, Triggers.",
        },
        {
          year: "2021",
          job: "Creación de WebService API Rest con Laravel / Udemy",
          description:
            "Manejo básico de Postman y Laravel para la creación de API's consultable y actualizable.",
        },
        {
          year: "2013 - 2019",
          job: "Ingeniero en Sistemas - UGMA",
          description:
            "Cursados 5 años de carrera de ingeniería en sistemas. Egresado de la Universidad Nor-Oriental Gran Mariscal de Ayacucho, aprendiendo conceptos del desarrollo y manejo de sistemas, junto con la administración y toma de decisiones en base a planificaciones.",
        },
      ],
      experiences: [
        {
          year: "2022",
          job: "Webmaster",
          description:
            "Mi trabajo consiste en mantener actualizadas en contenido e interacción las landings encargadas de aumentar las conversiones de usuarios que buscan en Alegra la solución que necesitan para sus problemas contables y administrativos. https://www.alegra.com",
        },
        {
          year: "2022",
          job: "E-commerce Wordpress",
          description:
            "Creación de E-commerce con CMS (Wordpress). Tienda virtual de ropa y/o uniformes deportivos dirigida mayoritariamente a niños. Uniformes completos o por piezas de equipos profesionales y contactos para uniformes personalizables (Editor: Elementor). http://hm21.com.ve",
        },
        {
          year: "2021",
          job: "Desarrollo de Blog Personal en Laravel",
          description:
            "Creación de blog personal con panel administrativo en laravel y diseño de maquetación web del cliente. Control de visitas por páginas, creación de usuarios y permisos de edición a usuarios, entre otras. http://feragoncoding.com",
        },
        {
          year: "2021",
          job: "Soporte Web (Tienda: Shopitmercado/ CMS: Wordpress)",
          description:
            "Corrección de problemas en panel de edición de productos, anexo de consultas al código fuente, modificación de pasillos. (Editor: X-Builder). http://shopitmercado.com",
        },
        {
          year: "2021",
          job: "Soporte Web (Tienda: Neotop/ CMS: Wordpress)",
          description:
            "Modificación y corrección de enlaces estáticos, cambios en la información de base de datos, conexión y migración de página web. (Editor: Elementor). http://neotop.cl",
        },
        {
          year: "2021",
          job: "Soporte Web (Tienda: Topoexpress/ CMS: Wordpress)",
          description:
            "Modificación y corrección de enlaces, cambios en la información de base de datos, anexo de consultas mysql necesarias (Editor: Elementor). http://topoexpress.com",
        },
        {
          year: "2021",
          job: "Redactor Web",
          description:
            "Redacción de artículos relacionados al marketing digital, ventajas y empresas relacionadas al mismo en zonas de españa. Incluyendo competitividad y diferencias con el marketing tradicional.",
        },
        {
          year: "2021",
          job: "Desarrollador Web",
          description:
            "Página Web desarrollada en PHP, con un buen maquetado HTML totalmente responsive y la aplicación de múltiples librerías Javascript, CSS y Bases de datos MySQL. http://gdlwebcampproject.epizy.com/",
        },
        {
          year: "2020 - 2021",
          job: "Administrador (Tienda: Shopitmercado/ CMS: Wordpress)",
          description:
            "Añadir, actualizar y eliminar productos de la tienda, modificaciones visuales, anexo de pasillos, corrección de errores. Supervisar el correcto funcionamiento del e-commerce. http://shopitmercado.com",
        },
        {
          year: "2019 - 2020",
          job: "Soporte Técnico",
          description:
            "Soporte técnico de equipos en empresa Desarrollos Tecnológicos Globales C.A. (DTGCA), soporte de múltiples equipos de escritorio y bases de datos en sistema aplicativo Saint's, actualización de licencias de clientes e instalación del sistema.",
        },
        {
          year: "2019 - 2020",
          job: "Coordinador",
          description:
            "Coordinador de turno encargado de la supervisión de docentes y alumnos en las materias básicas de la carrera de ingenieria en la Universidad Nor-Oriental Gran Mariscal de Ayacucho, supervisión de horarios, evaluaciones y atención de posibles desacuerdos entre estudiantes y docentes involucrados en el área bajo supervisión.",
        },
        {
          year: "2019",
          job: "Enlace de RR.HH",
          description:
            "Supervisar el ingreso y salida, control de horarios, permisos, solicitudes, dudas y quejas relacionadas al personal administrativo de la Universidad Nor-Oriental Gran Mariscal de Ayacucho.",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
  },
};
</script>

<style>
</style>